import {useReposAppPayload} from '@github-ui/code-view-shared/contexts/FilesPageInfoContext'
import {useCurrentRepository} from '@github-ui/current-repository'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import {CheckIcon, type Icon, InfoIcon, LawIcon, XIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import {clsx} from 'clsx'

import {useDeferredMetadata} from '../../../contexts/DeferredMetadataContext'
import styles from './BlobLicenseBanner.module.css'

export function BlobLicenseBanner() {
  const {license} = useDeferredMetadata()
  const repo = useCurrentRepository()
  const {helpUrl} = useReposAppPayload()

  const iconMap: {[group: string]: {icon: Icon; className: string}} = {
    permissions: {icon: CheckIcon, className: styles.permissionIcon},
    limitations: {icon: XIcon, className: styles.limitationIcon},
    conditions: {icon: InfoIcon, className: styles.conditionIcon},
  }

  if (!license) return null

  return (
    <div className={styles.Box}>
      {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
      <div className={clsx('blob-license-banner-outer', styles.Box_1)}>
        <div className={styles.Box_2}>
          <div className={styles.Box_3}>
            <LawIcon size={32} />
            <div className={styles.Box_4}>
              <div className={styles.Box_5}>
                {`${repo.ownerLogin}/${repo.name} is licensed under`}{' '}
                {license.name.toLowerCase().startsWith('the ') ? `` : ` the`}
              </div>
              <h3>{license.name}</h3>
            </div>
          </div>
          <VerifiedHTMLDiv html={license.description} className={styles.VerifiedHTMLBox} />
        </div>
        <div className={styles.Box_6}>
          {Object.keys(license.rules).map((group, index) => {
            const GroupIcon = iconMap[group]!.icon
            return (
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <div key={index} className={styles.Box_7}>
                <h5 className={styles.Box_8}>{group.charAt(0).toUpperCase() + group.substring(1)}</h5>
                {license.rules[group]!.map(rule => (
                  <div key={rule.tag} className={styles.Box_9}>
                    <GroupIcon size={13} className={clsx(styles.Octicon, iconMap[group]!.className)} />
                    {rule.label}
                  </div>
                ))}
              </div>
            )
          })}
        </div>
      </div>
      <div className={styles.Box_10}>
        This is not legal advice.&nbsp;
        <Link inline href={`${helpUrl}/articles/licensing-a-repository/#disclaimer`}>
          Learn more about repository licenses
        </Link>
      </div>
    </div>
  )
}
